import './headingAndViewAll.scss'

export function HeadingAndViewAll({ title, onClick, className }) {
    return <div className={`cards_top__head ${className}`}>
        <h2 className="title"> {title} </h2>
        <p onClick={onClick}>
            View all
        </p>
    </div>
}